export enum SalesDocumentDeliveryStatus {
  Sent = 'sent',
  Unsent = 'unsent',
  SendingFailed = 'sending-failed',
}
